import type { Pageable2Sort } from './pageable2Sort';

/**
 * 페이징 정보
 */
export interface Pageable2 {
  /** 오프셋 */
  offset?: number;
  /** 페이징 여부 */
  paged?: boolean;
  /** 페이지 번호 */
  pageNumber?: number;
  /** 페이지 크기 */
  pageSize?: number;
  /** 정렬 정보 */
  sort?: Pageable2Sort;
  /** 페이징 안 함 여부 */
  unpaged?: boolean;
}
